export const module = {
    info: {
        name: 'user-platform-employee-features',
        caption: 'user platform employee features'
    },
    vuexModules: ['api', 'state'],
    mainRoute: '/cpanel',
    noRoutes: true,
}

export default module
